var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_36833",
    "data-name": "Group 36833",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_483",
    "data-name": "Ellipse 483",
    cx: 23,
    cy: 23,
    r: 23,
    fill: "rgba(50,169,83,0.15)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7992",
    "data-name": "Path 7992",
    d: "M418.742,749.629l-.607,2.379,5.919,1.541-12.893,7.457,1.213,2.1,12.891-7.459-1.614,5.9,2.363.66,2.73-9.97Z",
    transform: "translate(-396.926 -733.337)",
    fill: "#32a953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenarrow);
export default __webpack_public_path__ + "static/media/greenarrow.3dd41c6f189b647c20635a98d800da58.svg";
export { ForwardRef as ReactComponent };